<template>
  <canvas id="swbganim" class="swbganim"></canvas>
</template>

<script>
import Particle from '../classes/Particle';

export default {
  name: 'AnimatedBackground',
  data() {
    return {
      particleNum: 20,
      canvas: null,
      context: null,
      particleArray: []
    }
  },
  props: {
  },
  computed: {},
  mounted() {
    this.canvas = document.querySelector('#swbganim');
    this.context = this.canvas.getContext('2d');

    this.context.canvas.width = window.innerWidth - 20;
    this.context.canvas.height = window.innerHeight;

    this.init();
    this.animate();

    window.addEventListener('resize', () => {
      this.canvas.width = window.innerWidth - 20;
      this.canvas.height = window.innerHeight;
      this.init();
    });
  },
  methods: {
    init() {
      this.particleArray = [];
      for(let i=0; i < this.particleNum; i++) {
        const size = Math.random() * 20;
        const x = Math.random() * (window.innerWidth - size * 2);
        const y = Math.random() * (window.innerHeight - size * 2);
        const directionX = (Math.random() * .4) - .2;
        const directionY = (Math.random() * .4) - .2;
        const color = 'white';
        
        this.particleArray.push(new Particle(x, y, directionX, directionY, size, color, this.canvas, this.context));
      } 
    },
    animate() {
      requestAnimationFrame(this.animate);
      this.context.clearRect(0, 0, window.innerWidth, window.innerHeight);
      
      for(let i=0; i < this.particleArray.length; i++) {
        this.particleArray[i].update();
      }
    }
  }
}
</script>

<style scoped lang="scss">
.swbganim {
  position: absolute;
  z-index: -1;
  opacity: 0.12;
  transition: 1s linear;
  left: 0;
  top: 0;
}
</style>
